import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LayoutRoute } from "@/components/LayoutRoute";
import { Grain } from "@/components/Grain";
import { SmoothScroll, ScrollToTop } from "@/components/SmoothScroll";

import Home from "@/pages/Home";
import Rooms from "@/pages/Rooms";
import RoomDetail from "@/pages/RoomDetail";
import Amenities from "@/pages/Amenities";
import IndoorPool from "@/pages/IndoorPool";
import TruckParking from "@/pages/TruckParking";
import ExtendedStay from "@/pages/ExtendedStay";
import BusinessTravel from "@/pages/BusinessTravel";
import FamilyTravel from "@/pages/FamilyTravel";
import GroupBookings from "@/pages/GroupBookings";
import Attractions from "@/pages/Attractions";
import Areas from "@/pages/Areas";
import Faq from "@/pages/Faq";
import Blog from "@/pages/Blog";
import Privacy from "@/pages/Privacy";
import AdminApp from "@/pages/AdminApp";

function App() {
  return (
    <div className="App">
      <Grain />
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Routes>
            <Route path="/admin" element={<AdminApp />} />
            <Route element={<LayoutRoute />}>
              <Route path="/" element={<Home />} />
              <Route path="/rooms" element={<Rooms />} />
              <Route path="/rooms/:slug" element={<RoomDetail />} />
              <Route path="/amenities" element={<Amenities />} />
              <Route path="/indoor-pool" element={<IndoorPool />} />
              <Route path="/truck-parking" element={<TruckParking />} />
              <Route path="/extended-stay" element={<ExtendedStay />} />
              <Route path="/business-travel" element={<BusinessTravel />} />
              <Route path="/family-travel" element={<FamilyTravel />} />
              <Route path="/group-bookings" element={<GroupBookings />} />
              <Route path="/attractions" element={<Attractions />} />
              <Route path="/areas" element={<Areas />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
